import Cookies from 'universal-cookie';
import findQhUserId from 'lib/findQhUserId';
import { createSelector } from 'reselect';
import { getLocation } from 'connected-react-router';
import { getRouteMatchForURL } from 'components/Routes';
import { getIsAuthenticated } from 'store/user/userSelectors';

const ARRIVED_LOGGED_IN = 'Arrived Logged In';
const ARRIVED_LOGGED_OUT = 'Arrived Logged Out';

const pageTypes = {
  'search-list': 'QH Search Page',
  'search-map': 'QH Map Page',
  property: 'QH Property Page',
  checkout: 'QH Booking Page',
  'booking-confirmation': 'QH Booking Confirmation Page',
  'contact-us-form': 'QH Contact Us Page',
  'contact-us': 'QH Email Us Form Page',
  faqs: 'QH FAQs Page',
  destination: 'QH Destination Page',
};

export const getCommonDataLayerVariables = createSelector([getIsAuthenticated, getLocation], (isAuthenticated, location) => {
  const cookies = new Cookies();

  const loggedInState = isAuthenticated ? ARRIVED_LOGGED_IN : ARRIVED_LOGGED_OUT;
  const { pathname, search } = location;

  const routeName = getRouteMatchForURL(pathname)?.name;
  const pageType = pageTypes[routeName] || 'Unknown Page';

  return {
    page: `${pathname}${search}`,
    pageType,
    qh_user_id: findQhUserId(cookies),
    qffLoggedInState: loggedInState,
  };
});
